import { Box } from '@frontend/legacy-components';

import { CustomDragSummary } from './components';
import { useEfficientDragLayer } from './components/customDragSummary/util';
import { getIsCustomDraggableItem } from './utils';

export const CustomDragLayer = () => {
  const { isDragging, clientOffset, description } = useEfficientDragLayer(
    (monitor) => ({
      isDragging:
        monitor.isDragging() && getIsCustomDraggableItem(monitor.getItem()),
      clientOffset: monitor.getClientOffset(),
      item: monitor.getItem(),
      description: monitor.getItem()?.description,
    }),
  );

  return isDragging && clientOffset ? (
    <Box
      position="fixed"
      pointerEvents="none"
      zIndex="customDragLayer"
      left={0}
      top={0}
      width="100%"
      height="100%"
    >
      <CustomDragSummary
        clientOffset={clientOffset}
        draggedItemDescription={description}
      />
    </Box>
  ) : null;
};
